import { render, staticRenderFns } from "./SystemClassification.vue?vue&type=template&id=49211a2f&scoped=true"
import script from "./SystemClassification.vue?vue&type=script&lang=js"
export * from "./SystemClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49211a2f",
  null
  
)

export default component.exports